<div class="calendar-container">
  <div class="first-view">
    <mat-calendar
      id="firstCalendarView"
      #firstCalendarView
      [startAt]="moment(firstCalendarViewData.startDate)"
      [selected]="selectedDates"
      (yearSelected)="firstCalendarYearSelected($event)"
      (monthSelected)="firstCalendarMonthSelected($event)"
      (selectedChange)="updateDateRangeSelection($event)"
      [minDate]="moment(minDate)"></mat-calendar>
  </div>
  <div class="second-view">
    <mat-calendar
      id="secondCalendarView"
      #secondCalendarView
      [startAt]="moment(secondCalendarViewData.startDate)"
      [maxDate]="moment(maxDate)"
      [selected]="selectedDates"
      (yearSelected)="secondCalendarYearSelected($event)"
      (monthSelected)="secondCalendarMonthSelected($event)"
      (selectedChange)="updateDateRangeSelection($event)"></mat-calendar>
  </div>
</div>
